/**
 * Last viewed position in a recording (`app/services/edf_position_service.py`).
 *
 * Split out of `brainfocus_api.ts` (FE Arch 1.0, #1165), which re-exports everything
 * here through the `BrainFocusApi` facade. Requests go through `client.request` so tests
 * can stub it on the module namespace.
 */
import * as client from '@brainfocus/web/api/client';
import { assertPojo } from '@brainfocus/web/api/response';

/** The current user's saved EEG preview position on a recording (#374). */
export async function getEdfPosition(edfId: number): Promise<EdfPosition> {
    const response = await client.request('GET', `/api/edfs/${edfId}/position`);
    assertPojo<EdfPosition>(response);
    return response;
}

/**
 * Save where the current user is in a recording: the start of the visible
 * window (#374). `keepalive` lets the request outlive the page when it is
 * sent while leaving it; `sendBeacon` cannot carry the CSRF header.
 */
export async function saveEdfPosition(edfId: number, positionSec: number, options: { keepalive?: boolean } = {}): Promise<void> {
    await client.request('PUT', `/api/edfs/${edfId}/position`, { positionSec }, options.keepalive ? { keepalive: true } : {});
}

/** The current user's saved EEG preview position on a recording (#374). */
export interface EdfPosition {
    positionSec: number | null;
    updatedAt: number | null;
}
